import React from "react";

const JumboLayoutHeaderContext = React.createContext({});

export default JumboLayoutHeaderContext;